import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismIcon, PrismTooltip } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { eq } from 'ember-truth-helpers';
import type { SmartInsightsUpsellPath } from 'lumen/services/smart-insights/upsell';

import styles from './badge-year-view.module.css';

interface GeneralSmartInsightsUpsellBadgeYearViewSignature {
  Args: {
    upsellPath: SmartInsightsUpsellPath;
  };
}

export default class GeneralSmartInsightsUpsellBadgeYearView extends Component<GeneralSmartInsightsUpsellBadgeYearViewSignature> {
  @service declare usageAnalytics: Services['usage-analytics'];

  onShowTooltip = (): void => {
    this.usageAnalytics.track('Upsell Trigger Viewed', {
      eventTrigger: 'smart-insights-spv-upsell-badge',
      product: 'smart-insights',
      upsellPath: this.args.upsellPath,
    });
  };

  <template>
    <div
      class="{{styles.badge}} flex items-center justify-center"
      data-test-id="smart-insights-upsell-badge"
    >
      <PrismIcon @color="default-inverse" @name="rocket" @size="small" />

      <PrismTooltip
        @onShow={{this.onShowTooltip}}
        @text={{if
          (eq @upsellPath "performance")
          (t "smart_insights.upsell.badge.tooltip.performance")
          (t "smart_insights.upsell.badge.tooltip.pricing")
        }}
      />
    </div>
  </template>
}
